import {
	initLocalization,
	config,
	fallbackLng,
} from '@adsk/alloy-react-localization'
import defaultLang from './en.json'

type Resources = Record<string, string>

const getLocale = async (locale: string): Promise<Resources> => {
	let lang = defaultLang
	try {
		lang = require(`./${locale}.json`)
	} catch (e) {}
	return lang
}

const { useTranslation, withTranslation } = initLocalization({
	getLocale,
	initOptions: {
		...config,
		fallbackLng: { ...fallbackLng, en: [] },
	},
})

export { useTranslation, withTranslation }
